import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class TableTimeInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let styleInfo = this.props.styleInfo
        let data = this.props.data
        if (data) {
            let splited = data.split(':')

            if (splited.length > 2) {
                data = splited[0] + ':' + splited[1]
            }
        }
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data && (
                    // <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{String(this.props.data)}</p>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>{String(data)}</p>
                )}
            </div>
        )
    }
}

export default TableTimeInput;